class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
        this.milestones = this.querySelectorAll('[data-milestone]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';

        this.progressMeter.style.transition = "width 0.5s ease";

        this.addEventListener('change', this.onCartChange.bind(this));
        this.initialize();
    }

    initialize() {
        if (window.__cartCache) {
            this.calculateProgress(window.__cartCache);
        }

        Shopify.getCart((cart) => {
            window.__cartCache = cart;
            this.calculateProgress(cart);
        });
    }

    onCartChange() {
        this.initialize();
    }

    calculateProgress(cart) {
        let totalItems = cart.item_count || 0;
        let freeShipBar = 0;
        let text = '';

        this.milestones.forEach(m => m.classList.remove('active'));

        if (totalItems === 0) {
            freeShipBar = 0;
            text = "Start your shine – Add your first item.";
        } else if (totalItems === 1) {
            freeShipBar = 33;
            text = "Great start! Add 2 more to unlock 3-for-1 offer.";
            this.milestones[0]?.classList.add('active');
        } else if (totalItems === 2) {
            freeShipBar = 66;
            text = "Almost there… Just 1 more to claim Buy 1 Get 2.";
            this.milestones[0]?.classList.add('active');
            this.milestones[1]?.classList.add('active');
        } else if (totalItems >= 3) {
            freeShipBar = 100;
            text = "Offer Unlocked – Pay for 1, enjoy 3 premium jewels.";
            this.milestones.forEach(m => m.classList.add('active'));
        }

        const classLabel = this.getClassLabel(freeShipBar);
        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getClassLabel(freeShipBar) {
        if (freeShipBar === 0) return 'none';
        if (freeShipBar <= 33) return FreeShippingMeter.classLabel1;
        if (freeShipBar <= 66) return FreeShippingMeter.classLabel2;
        if (freeShipBar < 100) return FreeShippingMeter.classLabel3;
        return 'progress-free';
    }

    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30', 'progress-60', 'progress-100', 'progress-free');
        if (classLabel && classLabel !== 'none') {
            this.progressBar.classList.add(classLabel);
        }
    }

    setProgressWidthAndText(freeShipBar, text, classLabel) {
        this.resetProgressClass(classLabel);

        requestAnimationFrame(() => {
            this.progressMeter.style.width = `${freeShipBar}%`;
        });

        if (this.textEnabled) {
            this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar.toFixed(0)}%`;
        }

        this.messageElement.innerHTML = text;
    }
}

window.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('free-shipping-component')) {
        customElements.define('free-shipping-component', FreeShippingMeter);
    }
});
